export const GETDITAUTHTOKEN = 'GETDITAUTHTOKEN'
export const GETDITAUTHTOKEN_RESPONSE = 'GETDITAUTHTOKEN_RESPONSE'
export const GETDITAUTHTOKEN_FAILED = 'GETDITAUTHTOKEN_FAILED'